import React, { useState } from "react";
import { Input, Row, Col, Button, Form } from "antd";
import { verticalFormLayout } from "../../utils/forms";
import { forgot } from "../../utils/auth";
import "./forgot.css";
import logoLS from "../../assets/logo/linksight-logo.svg";

const Forgot = () => {
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    await forgot(values.email);
    setEmailSent(true);
    setLoading(false);
  };

  const onFinishFailed = () => {
    console.log("Erreur");
  };

  return (
    <div className="signin-container">
      <Row>
        <Col xl={8} lg={8} md={24} sm={24} xs={24}>
          <div className="block-signin">
            <div className="heading-auth">
              <div className="logo-ls">
                <img src={logoLS} alt="logo linksight" width="190px" />
              </div>
              <span>Mot de passe oublié ?</span>
            </div>

            <div className="signin-local">
              {!emailSent && (
                <>
                  {" "}
                  <Form
                    {...verticalFormLayout}
                    layout="vertical"
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    // className="align-left"
                  >
                    <Form.Item
                      // className="no-margin"
                      label="Email"
                      name="email"
                      rules={[
                        { required: true, message: "Insérez votre email" },
                      ]}
                    >
                      <Input
                        className="auth-input"
                        placeholder="elon@tesla.com"
                      />
                    </Form.Item>
                    <Form.Item>
                      <Button
                        className="signup-button"
                        type="secondary"
                        htmlType="submit"
                        loading={loading}
                        size="large"
                      >
                        Demander un nouveau mot de passe
                      </Button>
                    </Form.Item>
                  </Form>
                </>
              )}
              {emailSent && (
                <>
                  <span className="success-reset">
                    <span
                      role="img"
                      aria-label="emoji"
                      style={{ marginRight: "10px" }}
                    >
                      ✅
                    </span>
                    <span style={{ lineHeight: "40px" }}></span>
                    Nous venons de vous envoyer un email ! Si votre adresse
                    email fait partie de notre base de données,{" "}
                    <b>vous avez reçu un email</b> pour{" "}
                    <b>configurer votre mot de passe</b>.
                  </span>
                </>
              )}
            </div>
          </div>
        </Col>
        <Col
          xl={16}
          lg={16}
          md={24}
          sm={24}
          xs={24}
          className="block-image"
        ></Col>
      </Row>
    </div>
  );
};

export default Forgot;
